import { checkin as en_checkin } from "../en/checkin";

/** checkin — ES slice (120 keys). */
export const checkin: Record<keyof typeof en_checkin, string> = {
  checkin_launcher_subtitle:
    "Haz check-in en un evento Linqx cercano para conectar, jugar y ganar CP — abre Check In para empezar.",
  checkin_launcher_open_button: "Check In",
  checkin_map_title: "Check In",
  checkin_map_tap_event: "Toca un evento en el mapa para hacer check-in",
  checkin_map_no_nearby: "No hay eventos Linqx cerca ahora mismo.",
  checkin_map_location_denied:
    "La ubicación está desactivada. Actívala para encontrar eventos cercanos, o escanea un QR.",
  checkin_map_you_are_here: "Estás aquí",
  checkin_map_scan_instead: "Escanea para hacer Check In",
  checkin_card_check_in_button: "Check In",
  checkin_card_scan_button: "Escanea para hacer Check In",
  checkin_card_try_again_button: "Intentar de nuevo",
  checkin_card_potential_linqx: "{count} Linqx potenciales",
  checkin_card_geofence_error:
    "Aún no estás en el lugar — a unos {distance}m. Acércate e intenta de nuevo.",
  checkin_scan_title: "Nuevo Check In",
  checkin_scan_point_camera: "Apunta la cámara al código QR del evento.",
  checkin_scan_camera_help:
    "Activa la cámara para escanear, o pega el código del evento abajo.",
  checkin_scan_enable_camera: "Activar cámara",
  checkin_scan_paste_placeholder: "Pega el código del evento",
  checkin_scan_submit: "Check In",
  checkin_scan_checking_in: "Haciendo check-in…",
  checkin_scan_invalid_code: "Eso no parece un código de check-in de evento.",
  checkin_back: "Atrás",
  checkin_back_to_dashboard: "Volver al panel",
  checkin_activity_coming_soon: "Esta actividad llegará pronto.",
  checkin_dashboard_checked_in: "¡Check-in hecho!",
  checkin_dashboard_cp_amount: "+{cp} CP",
  checkin_dashboard_qr_connect: "Conectar por QR",
  checkin_dashboard_activities: "Actividades",
  checkin_dashboard_top_mixers: "Mejores mixers",
  checkin_dashboard_see_full_board: "Ver tabla completa",
  checkin_dashboard_no_active: "Aún no has hecho check-in en ningún evento.",
  checkin_dashboard_back_to_map: "Volver al mapa",
  checkin_activity_speed_linq: "Speed Linq",
  checkin_activity_mini_games: "Minijuegos",
  checkin_activity_photo: "Reto de fotos",
  checkin_activity_social_share: "Compartir en redes",
  checkin_activity_invite: "Invitar amigos",
  checkin_action_play: "Jugar",
  checkin_action_join: "Unirse",
  checkin_action_camera: "Cámara",
  checkin_action_share: "Compartir",
  checkin_action_invite: "Invitar",
  checkin_photo_title: "Reto de fotos",
  checkin_photo_timeline_hint: "Cronología del evento · gana +10 CP por foto",
  checkin_photo_empty: "Aún no hay fotos. ¡Sé el primero en compartir una!",
  checkin_photo_just_now: "ahora mismo",
  checkin_photo_take: "Tomar foto",
  checkin_photo_cap_reached: "Ya has compartido tus 3 fotos.",
  checkin_photo_remaining: "Te quedan {count} fotos",
  checkin_photo_report: "Reportar",
  checkin_photo_reported: "Foto reportada.",
  checkin_photo_submitting: "Subiendo…",
  checkin_leaderboard_title: "Mejores mixers",
  checkin_leaderboard_empty:
    "Aún no hay mixers en el ranking. ¡Gana CP para subir en la tabla!",
  checkin_leaderboard_finalized: "Resultados finales",
  checkin_leaderboard_updates: "Se actualiza cada 2 min",
  checkin_leaderboard_pts: "{count} pts",
  checkin_leaderboard_you: "Tú",
  checkin_invite_title: "Invitar amigos",
  checkin_invite_heading: "Invita amigos y gana 25 CP",
  checkin_invite_subtitle:
    "Gana +25 CP cada vez que un amigo se una con tu código y complete su registro.",
  checkin_invite_your_code: "Tu código de referido",
  checkin_invite_copy: "Copiar código",
  checkin_invite_copied: "Copiado ✓",
  checkin_invite_how_it_works: "Cómo funciona",
  checkin_invite_step_1: "Comparte tu código con un amigo",
  checkin_invite_step_2: "Lo introduce al registrarse",
  checkin_invite_step_3: "Completa el onboarding",
  checkin_invite_step_4: "Ganas +25 CP",
  checkin_invite_footnote:
    "Referido de eventos — solo por código. Los créditos aparecen en el Historial de puntos.",
  checkin_games_title: "Minijuegos",
  checkin_games_join_heading: "Únete a un juego",
  checkin_games_code_placeholder: "Introduce el código para unirte",
  checkin_games_join_button: "Unirse al juego →",
  checkin_games_live_heading: "En vivo ahora en este evento",
  checkin_games_join: "Unirse",
  checkin_games_type_who_said_it: "¿Quién lo dijo?",
  checkin_games_type_two_truths: "Dos verdades y una mentira",
  checkin_games_status_lobby: "Esperando jugadores…",
  checkin_games_status_in_progress: "En curso",
  checkin_games_players: "{count} jugadores",
  checkin_games_code_label: "Código {code}",
  checkin_games_empty:
    "Aún no hay juegos en curso — el organizador no ha iniciado ninguno.",
  checkin_games_organizer_note: "Los juegos los inicia el organizador",
  checkin_games_joining: "Uniéndose…",
  checkin_game_title_who_said_it: "¿Quién lo dijo?",
  checkin_game_title_two_truths: "Dos verdades y una mentira",
  checkin_game_round: "Ronda {current}/{total}",
  checkin_game_waiting: "Esperando a que empiece la ronda…",
  checkin_game_prompt_who_said_it: "¿Quién lo dijo?",
  checkin_game_prompt_two_truths: "¿Cuál es la mentira?",
  checkin_game_your_score: "Tu puntuación {score}",
  checkin_game_next: "Siguiente →",
  checkin_game_finish: "Finalizar →",
  checkin_game_over: "Juego terminado",
  checkin_game_final_score: "Puntuación final {score}",
  checkin_game_completed: "completado",
  checkin_game_completed_winner: "completado + ganador",
  checkin_game_capped: "Has alcanzado el límite diario de CP por juegos",
  checkin_game_back_to_event: "Volver al evento",
  checkin_game_ended: "Este juego ha terminado.",
  checkin_game_dropped: "Fuiste sacado del juego — no se otorgaron CP.",
  checkin_speed_title: "Speed Linq",
  checkin_speed_intro_heading: "60 segundos. Toca rápido.",
  checkin_speed_intro_body:
    "Dale like a las personas que quieras conocer antes de que se acabe el tiempo. Gana +10 CP por jugar.",
  checkin_speed_start: "Empezar",
  checkin_speed_like: "Like",
  checkin_speed_skip: "Saltar",
  checkin_speed_already_liked: "Con like",
  checkin_speed_time_left: "{seconds}s",
  checkin_speed_empty: "Aún no hay nadie más por conocer aquí — vuelve pronto.",
  checkin_speed_done_heading: "¡Se acabó el tiempo!",
  checkin_speed_liked_count: "Diste like a {count} personas",
  checkin_speed_done: "Listo",
  checkin_share_title: "Comparte este evento",
  checkin_share_subtitle: "#LinqxMixer · gana +25 CP cuando vuelvas",
  checkin_share_shared_heading: "¡Compartido! Vuelve para reclamar",
  checkin_share_credited_note: "(se acredita al volver, una vez por evento)",
  checkin_share_done: "Listo",
  checkin_share_already: "Ya has reclamado los CP por compartir este evento.",
};
